import React, { useState, useEffect, useRef } from 'react';

const DynamicMultiSelect = ({ initialOptions, selectedOptions, setSelectedOptions, name }) => {
  const [availableOptions, setAvailableOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    // Filter the options to exclude selected ones
    setAvailableOptions(initialOptions.filter(option => !selectedOptions.includes(option)));
  }, [selectedOptions, initialOptions]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleSelect = (option) => {
    setSelectedOptions([...selectedOptions, option]);
    setIsOpen(false); // Close dropdown after selection
  };

  const removeOption = (option, event) => {
    event.stopPropagation(); // Stop the dropdown from toggling
    setSelectedOptions(selectedOptions.filter(selected => selected !== option));
  };

  const clearAll = () => {
    setSelectedOptions([]);
  };

  return (
    <div ref={containerRef} className='relative' style={{ width: 215 }}>
      <div className='flex flex-wrap gap-2 p-2 border-2 rounded' onClick={toggleDropdown}>
        {selectedOptions.map(option => (
          <span key={option} className='bg-blue-100 rounded px-2 py-1 flex items-center'>
            {option}
            <button onClick={(e) => removeOption(option, e)} className='ml-2 text-red-500'>×</button>
          </span>
        ))}
        {!selectedOptions.length && <span className='flex-1 cursor-text' onClick={toggleDropdown}>{name}</span>}
        {selectedOptions.length > 0 && (
          <button onClick={clearAll} className='text-red-500 text-sm ml-auto'>
            &#x2715;
          </button>
        )}
      </div>
      {isOpen && availableOptions.length > 0 && (
        <div className='absolute w-full max-h-[200px] mt-2 border-sm rounded-md z-10 bg-slate-50 overflow-auto'>
          {availableOptions.map(option => (
            <p 
              key={option} 
              onClick={() => handleSelect(option)}
              className='p-1.5 hover:bg-gray-200 hover:cursor-pointer border-b'
            >
              {option}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default DynamicMultiSelect;
